import { useOidc } from "@axa-fr/react-oidc"
import { vars } from "@janeapp/burrito-design-system"
import { Outlet } from "react-router-dom"
import styled, { css } from "styled-components"
import { AccountFooter } from "../../components/AccountFooter"
import { AccountHeader } from "../../components/AccountHeader"

const Page = styled.div(
  () => css`
    min-height: 100vh;
    background: ${vars.alias.background.color.neutral.default};
  `
)

export const Layout = () => {
  const { logout } = useOidc()

  return (
    <Page>
      <div className="mx-auto flex w-full max-w-[648px] flex-col gap-6 px-6 pb-6 pt-6 sm:pt-12">
        <AccountHeader logout={logout} />
        <Outlet />
        <AccountFooter />
      </div>
    </Page>
  )
}
